import {
  isDefinedString,
  isNullOrUndefined,
  isPositiveNumber,
  reduce
} from "et3-type-guards";
import { memoize } from "lodash";
import { computed, observable, runInAction } from "mobx";
import { TCorePage, TTableSearchInput } from "../../../Types";
import getCorePersonalStore from "../core-personal-store";

class CoreUIStore {
  rotateDevice = observable.box<boolean>(false);
  windowWidth = observable.box<number>(window.innerWidth);
  windowHeight = observable.box<number>(window.innerHeight);
  isProfileDropdownVisible = observable.box<boolean>(false);
  isSideBarVisible = observable.box<boolean>(false);
  userDropdownIsOpen = observable.box<boolean>(false);
  devZoneDropdownIsOpen = observable.box<boolean>(false);
  qaZoneDropdownIsOpen = observable.box<boolean>(false);
  communicationZoneDropdownIsOpen = observable.box<boolean>(false);
  CSRDropdownIsOpen = observable.box<boolean>(false);
  scsrDropdownIsOpen = observable.box<boolean>(false);
  AuditorDropdownIsOpen = observable.box<boolean>(false);
  supervisorDropdownIsOpen = observable.box<boolean>(false);
  khattabatDropdownIsOpen = observable.box<boolean>(false);

  isPageLoading = observable.map<TCorePage, boolean>();
  isLatestDataLoading = observable.box<boolean>(false);
  tablesSearchInput = observable.box<TTableSearchInput>({});
  buttonInActionState = observable.map<string, boolean>();
  buttonLocked = observable.box<boolean>(false);

  constructor() {
    window.addEventListener("resize", () => this.handleWindowResize());
    window.addEventListener("load", () => this.handleWindowResize());
  }
  isAdminLoading = computed(() => {
    const loadingLength = Array.from(this.isPageLoading.values()).filter(
      (item) => item
    ).length;
    return loadingLength > 0;
  });
  setIsLoading = (page: TCorePage, isLoading: boolean) => {
    this.isPageLoading.set(page, isLoading);
  };
  setLatestDataLoading = (isLatestDataLoading: boolean) => {
    this.isLatestDataLoading.set(isLatestDataLoading);
  };
  setButtonInAction = (buttonID: string, state: boolean) => {
    const isDefinedButtonID = isDefinedString(buttonID);
    if (isDefinedButtonID) {
      return runInAction(() => {
        this.buttonInActionState.set(buttonID, state);
      });
    }
    return;
  };
  handleWindowResize = () => {
    const newWidth = window.innerWidth;
    const newHeight = window.innerHeight;
    if (newWidth < newHeight) {
      this.rotateDevice.set(true);
    } else {
      this.rotateDevice.set(false);
    }
    this.windowWidth.set(newWidth);
    this.windowHeight.set(newHeight);
  };

  toggleProfileDropdown = () => {
    const status = this.isProfileDropdownVisible.get();
    this.isProfileDropdownVisible.set(!status);
  };

  setSideBarVisisble = (sideBarVisible: boolean) => {
    this.isSideBarVisible.set(sideBarVisible);
  };

  getExistingSearchTableStates = (id: string) => {
    if (isNullOrUndefined(this.tablesSearchInput.get())) {
      return false;
    }
    const existingTablesSearchData = Object.keys(this.tablesSearchInput.get());
    const datasExist = existingTablesSearchData.indexOf(id) > -1;
    return datasExist;
  };
  setTableSearchTextById = (id: string, text: string) => {
    const datasExist = this.getExistingSearchTableStates(id);

    runInAction(() => {
      if (datasExist) {
        this.tablesSearchInput.get()[id].searchText = text;
      } else {
        this.tablesSearchInput.set({
          ...this.tablesSearchInput.get(),
          [id]: { searchText: text, sensitiveCaseState: false }
        });
      }
    });
  };
  setTableSearchSensitiveCaseById = (id: string) => {
    const datasExist = this.getExistingSearchTableStates(id);

    runInAction(() => {
      if (datasExist) {
        this.tablesSearchInput.get()[id].sensitiveCaseState =
          !this.tablesSearchInput.get()[id].sensitiveCaseState;
      } else {
        this.tablesSearchInput.set({
          ...this.tablesSearchInput.get(),
          [id]: { searchText: "", sensitiveCaseState: true }
        });
      }
    });
  };

  getTableSearchTextInput = (id: string) => {
    const datasExist = this.getExistingSearchTableStates(id);

    if (datasExist) {
      return this.tablesSearchInput.get()[id].searchText;
    }
    return "";
  };

  getTableSearchSensitiveCaseInput = (id: string) => {
    const datasExist = this.getExistingSearchTableStates(id);

    if (datasExist) {
      return this.tablesSearchInput.get()[id].sensitiveCaseState;
    }
    return false;
  };

  getButtonInActionState = (buttonID: string) => {
    const buttonState = reduce(
      () => this.buttonInActionState.get(buttonID),
      false
    );
    return buttonState;
  };

  shouldShowSideBar = computed(() => {
    return (
      getCorePersonalStore().adminServiceIsActive() &&
      isPositiveNumber(reduce(() => getCorePersonalStore().user.get().id, 0))
    );
  });

  mainWidth = computed(() => {
    const sideBarVisible = getCoreUIStore().shouldShowSideBar.get();
    return sideBarVisible ? 1620 : 1920;
  });
}

const getCoreUIStore = memoize(
  () => new CoreUIStore(),
  () => 1
);
export default getCoreUIStore;
